import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image2 from "./images/image1/2.jpeg";
import image1 from "./images/image1/1.jpeg";
import image3 from "./images/image1/3.jpeg" ;
import image4 from "./images/image1/4.jpeg" ;
import image5 from "./images/image1/5.jpeg";
import image6 from "./images/image1/6.jpeg";

const HackMinds = () => {
    const images = [image1,image2,image3, image4, image5,image6];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">Sustainable Minds²</h2>
        <span className="section__subtitle">Third Place winner🥉</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🎉 We are proud to have secured the <strong>3rd place 🥉</strong> in the <strong>"Sustainable Minds²" Hackathon</strong>, which took place from March 1st to 3rd, 2024.
                    </p>
                    <p className='redRadio__text'>
                        🎯 Regarding our project in the hackathon, we focused on addressing <strong>SDG 6 (clean water and sanitation)</strong>.
                    </p>
                    <p className='redRadio__text'>
                        💧 Our solution, <strong>"WaterMe"</strong>, aims to empower both individuals and industries to monitor their water consumption effectively.
                    </p>
                    <p className='redRadio__text'>
                        📊 Key features include:
                    </p>
                    <ul className="achievement__list">
                        <li className='redRadio__text'>• Smart water meters for real-time data</li>
                        <li className='redRadio__text'>• Leak detection capabilities</li>
                        <li className='redRadio__text'>• Predictive models for consumption patterns</li>
                        <li className='redRadio__text'>• Intuitive dashboards for enhanced visibility</li>
                        <li className='redRadio__text'>• Challenges to encourage sustainable practices</li>
                    </ul>
                    <p className='redRadio__text'>
                        🚀 I'm genuinely grateful for this enriching experience and eagerly look forward to embracing similar challenges in the future!
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default HackMinds;
